import { MainButtonProps } from '@/components/ui/custom/buttons/MainButton';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import { ListCourseProgressFilters } from '@/data/services/courseProgressServices';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { ProgressStatusEnum } from '@/enums/ProgressStatusEnum';
import CourseLineFilter from '@/components/ui/custom/dataInput/CourseLineFilter';

export type CourseProgressSectionHeaderProps = {
  section?: ProgressStatusEnum;
  hiddenFilter?: boolean;
  filters?: ListCourseProgressFilters;
  onFilter?: (filters: ListCourseProgressFilters) => void;
  button?: React.ReactElement<MainButtonProps>;
  className?: Pick<ClassNameComponent, 'title'>;
};

export default function CourseProgressSectionHeader({
  section = ProgressStatusEnum.IN_PROGRESS,
  filters,
  hiddenFilter,
  onFilter,
  className,
  button,
}: CourseProgressSectionHeaderProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'coursesView.student',
  });

  const sectionTitle = t(`section.${section}`);

  return (
    <div className="relative flex justify-between w-full gap-2.5 items-center">
      <div className="flex gap-x-2 gap-y-1 flex-wrap items-center">
        <Text
          format="rubik-500"
          size="text-18"
          text={sectionTitle}
          className={twMerge(
            'text-accent',
            section === ProgressStatusEnum.IN_PROGRESS
              ? 'text-warning'
              : 'text-success',
            className?.title,
          )}
        />
        <ConditionalRenderer condition={!hiddenFilter}>
          <CourseLineFilter filter={filters} onFilter={onFilter} />
        </ConditionalRenderer>
      </div>
      {button}
    </div>
  );
}
